module.exports = __webpack_public_path__ + "img/medium_grege.fc582065.jpg";